import K from "./constants";
import restHelpers from "../helpers/restHelper";

const makers = () => restHelpers.withBearer.get(`${K.API_URL}/api/v1/qt/brands`, {});
const models = maker => restHelpers.withBearer.get(`${K.API_URL}/api/v1/qt/models/${maker}`, {});
const types = model => restHelpers.withBearer.get(`${K.API_URL}/api/v1/qt/types/${model}`, {});
const infocar = infocarAm => restHelpers.withBearer.get(`${K.API_URL}/api/v1/qt/infocar/${infocarAm}`, {});
const confMunic = (imei, alimentation, displacement) => restHelpers.withBearer.post(`${K.API_URL}/api/v1/munic/assets/${imei}/configure`, { data: { alimentation, displacement } });
const confMunicShutdown = imei => restHelpers.withBearer.post(`${K.API_URL}/api/v2/munic/assets/${imei}/deactivation`, {});
const municSubscribeOffer = (imei, vin) => restHelpers.withBearer.post(`${K.API_URL}/api/v2/munic/assets/${imei}/${vin}/subscribe`, {data: {}});
const registerVehicle = imei => restHelpers.withBearer.post(`${K.API_URL}/api/v2/munic/vehicles/registration/${imei}?save`, {data: {}});
const motorbikeMakers = async () => {
  const brands = [];
  await restHelpers.withBearer.get(`${K.API_URL}/api/v2/infocar/qt/motorbike/brands`, {}).then(res => {
    res.brands.forEach(element => {
      brands.push({codiceMarca : element.id, descrizione : element.attributes && element.attributes.name})
    });
  });

  return brands;
};
const motorbikeModels = async maker => {
  let models = [];
  await restHelpers.withBearer.get(`${K.API_URL}/api/v2/infocar/qt/motorbike/models/${maker}`, {}).then(res => {
    res.models.forEach(element =>{
      models.push({ codiceModello: element.id, descrizione : element.attributes && element.attributes.name, descrizioneComplessa : 's'});
    })
  });
  return models;
};
const motorbikeTypes = async model => {
  let types = [];
  await restHelpers.withBearer.get(`${K.API_URL}/api/v2/infocar/qt/motorbike/types/${model}`, {}).then(res => {
    res.types.forEach(element => {
      if (element.attributes) {
        types.push({
          codiceInfocar: element.attributes.code,
          codiceInfocarAM: element.id,
          anno: element.attributes.year,
          descrizione: element.attributes.description ? element.attributes.description : element.attributes.full_description,
          categoria: element.attributes.category,
          inizioVendita: element.attributes.selling_start_date,
          fineVendita: element.attributes.selling_end_date,
          inizioImmatricolazione: element.attributes.registration_start_date,
          fineImmatricolazione: element.attributes.registration_end_date,
          descrizioneCompleta: element.attributes.full_description
        });
      }
    });
  });
  return types;
};

const infocarMotorbike = infocarAm => restHelpers.withBearer.get(`${K.API_URL}/api/v2/infocar/qt/motorbike/infocar/${infocarAm}`, {});

export default {
  makers,
  models,
  types,
  motorbikeMakers,
  motorbikeModels,
  motorbikeTypes,
  infocar,
  infocarMotorbike,
  confMunic,
  confMunicShutdown,
  municSubscribeOffer,
  registerVehicle
};



// WEBPACK FOOTER //
// ./src/services/vehicle.js